import { render, staticRenderFns } from "./loginAdmin.vue?vue&type=template&id=65aec000&scoped=true"
import script from "./loginAdmin.vue?vue&type=script&lang=js"
export * from "./loginAdmin.vue?vue&type=script&lang=js"
import style0 from "./loginAdmin.vue?vue&type=style&index=0&id=65aec000&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65aec000",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65aec000')) {
      api.createRecord('65aec000', component.options)
    } else {
      api.reload('65aec000', component.options)
    }
    module.hot.accept("./loginAdmin.vue?vue&type=template&id=65aec000&scoped=true", function () {
      api.rerender('65aec000', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/loginAdmin.vue"
export default component.exports